import { tickerItems } from "@/mocks/home";

export default function NewsTicker() {
  const doubled = [...tickerItems, ...tickerItems];

  return (
    <div className="border-b border-background-200/80 bg-background-100">
      <div className="mx-auto flex w-full max-w-[1240px] items-center gap-3 px-4 py-2 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 rounded-full bg-primary-100 px-2.5 py-1 text-xs font-medium text-primary-700">
          <span className="flex h-3 w-3 items-center justify-center">
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-primary-500" />
          </span>
          正在更新
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="marquee-track">
            {doubled.map((item, index) => (
              <span
                key={`${item}-${index}`}
                className="flex items-center whitespace-nowrap pr-8 text-xs text-foreground-600 md:text-[13px]"
              >
                <span className="mr-2 text-primary-500" aria-hidden="true">
                  ·
                </span>
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}